import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import stl from "./Radio.module.css";
var Radio = function Radio(_ref) {
  var label = _ref.label,
    name = _ref.name,
    value = _ref.value,
    setAnswer = _ref.setAnswer,
    answers = _ref.answers,
    setError = _ref.setError,
    isCheckBox = _ref.isCheckBox;
  var handleChange = function handleChange(val) {
    setAnswer(function (pre) {
      return _objectSpread(_objectSpread({}, pre), {}, {
        secondaryAnswer: [val]
      });
    });
    setError("");
  };
  var handleCheckBoxChange = function handleCheckBoxChange(val) {
    setError("");
    if (answers.includes(value.toString())) {
      setAnswer(function (pre) {
        return _objectSpread(_objectSpread({}, pre), {}, {
          secondaryAnswer: pre.secondaryAnswer.filter(function (answer) {
            return answer !== val;
          })
        });
      });
      return;
    }
    setAnswer(function (pre) {
      return _objectSpread(_objectSpread({}, pre), {}, {
        secondaryAnswer: [].concat(_toConsumableArray(pre.secondaryAnswer), [val])
      });
    });
  };
  return /*#__PURE__*/React.createElement("label", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement("input", {
    type: isCheckBox ? "checkbox" : "radio",
    name: name,
    value: value,
    onChange: function onChange(e) {
      return isCheckBox ? handleCheckBoxChange(e.target.value) : handleChange(e.target.value);
    },
    checked: answers.includes(value.toString())
  }), label, /*#__PURE__*/React.createElement("span", {
    className: isCheckBox ? stl.customRaduis : ""
  }));
};
export default Radio;